import React from 'react';
import classNames from 'classnames';
import InputLabel from '../InputLabel/InputLabel';
import InputError from '../InputError/InputError';
import { DAYS_OF_WEEK_SHORT_OPTIONS } from 'constants/date';

export default function WeekDaySelector({
  label,
  value = [],
  onChange,
  error,
  className = '',
}) {
  const toggleDay = (dayId) => {
    const newValue = value.includes(dayId)
      ? value.filter(id => id !== dayId)
      : [...value, dayId];
    onChange(newValue);
  };

  return (
    <div className={className}>
      {label && <InputLabel className="mb-2">{label}</InputLabel>}
      <div className="flex flex-wrap gap-2">
        {DAYS_OF_WEEK_SHORT_OPTIONS.map((day) => {
          const isSelected = value.includes(day.id);
          return (
            <button
              key={day.id}
              type="button"
              onClick={() => toggleDay(day.id)}
              className={classNames(
                "flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-900 cursor-pointer",
                isSelected
                  ? "bg-indigo-600 text-white hover:bg-indigo-500"
                  : "bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white ring-1 ring-inset ring-white/10"
              )}
            >
              {day.label}
            </button>
          );
        })}
      </div>
      {error && <InputError className="mt-2">{error}</InputError>}
    </div>
  );
}
